import React from "react";
import { connect } from "react-redux";
import { any, func } from "prop-types";
import moment from "moment";
import history from "../../history";
import FormCreatorV2 from "../../common/FormCreatorV2";
import { postCompleatFoodForm } from "../../redux/actions/index";
import {
  formCreatorConvertToValues,
  getField,
  useForm,
} from "../../common/FormCreator/helpers";
import buildAddress from "./helpers";

const ConsentForHealthScreeningForm = ({ appData, postForm }) => {
  const initialData = {
    name: `${appData.firstName} ${appData.lastName}`,
    dateOfBirth:
      appData.dateOfBirth && moment(appData.dateOfBirth).format("DD/MM/YYYY"),
    address: buildAddress(appData, true),
    jobRole: "",
    company: "Compleat Food",
    healthScreening: "",
    dateOfAssessment: "",
    nationalInsuranceNumber: appData.nationalInsuranceNo,
    giveConsent: "",
    signature: `${appData.firstName} ${appData.lastName}`,
    date: moment().format("DD/MM/YYYY"),
  };
  const getVal = getField(initialData);

  const initialState = {
    blurb1: {
      htmlObj: (
        <div className={"text-center"}>
          <strong>
            To be completed by all employees undertaking health screening.
          </strong>
        </div>
      ),
    },

    name: {
      title: "Employee Name",
      value: getVal("name"),
      mandatory: true,
      disabled: true,
    },
    dateOfBirth: {
      type: "date",
      title: "Employee Date of Birth",
      value: getVal("dateOfBirth"),
      mandatory: true,
    },
    nationalInsuranceNumber: {
      title: "Employee NI Number",
      value: getVal("nationalInsuranceNumber"),
      mandatory: true,
    },
    address: {
      title: "Employee Address",
      value: getVal("address"),
      mandatory: true,
    },
    jobRole: {
      title: "Job Role",
      value: getVal("jobRole"),
      mandatory: true,
    },
    company: {
      type: "text",
      title: "Company",
      value: getVal("company"),
      mandatory: true,
      disabled: true,
    },
    healthScreening: {
      title: "Health Screening",
      value: getVal("healthScreening"),
    },
    dateOfAssessment: {
      type: "date",
      title: "Date of Assessment",
      value: getVal("dateOfAssessment"),
    },
    blurb2: {
      htmlObj: (
        <div>
          <p>
            I understand that the health surveillance / health screening
            assessments will be carried out by the Occupational Health Advisor
            on behalf of my employer.
          </p>
          <p>
            I understand that the medical information gathered will remain
            confidential to Compleat Food Group, Occupational Health Department.
            Information will be kept in accordance with the General Data
            Protection Regulation.
          </p>
          <p>
            I understand that an opinion on my medical fitness for work for the
            above role, or any proposed role as stated above, will be forwarded
            to my employer along with any medical recommendations.
          </p>
          <p>
            I hereby <strong>do / do not*</strong> consent to be seen by
            Occupational Health and to undergo any relevant health surveillance
            / health screening assessments required for the purpose of my job
            role.
            <p>
              <i>*please indicate below as appropriate</i>
            </p>
          </p>
        </div>
      ),
    },
    giveConsent: {
      key: "giveConsent",
      value: getVal("giveConsent"),
      type: "checkbox",
      checkboxText1: "DO",
      checkboxText2: "DO NOT",
      mandatory: true,
    },

    signature: {
      title: "Employee Signature",
      value: getVal("signature"),
      mandatory: true,
      disabled: true,
    },
    date: {
      title: "Date",
      value: getVal("date"),
      mandatory: true,
      disabled: true,
    },
  };
  const [fields, setField] = useForm(initialState);
  const submitted =
    appData.compleatFoodOnboarding && appData.compleatFoodOnboarding.YCF3;

  const redirectBack = () => {
    history.push("/profile/edit/compleat-food-onboarding");
  };

  const handleSubmit = () => {
    const fieldValuesPayload = formCreatorConvertToValues(fields);
    postForm("YCF3", {
      ...fieldValuesPayload,
    });
    redirectBack();
  };

  return (
    <>
      {submitted ? (
        redirectBack()
      ) : (
        <FormCreatorV2
          formTitle={"Consent for Health Screening Form"}
          fields={fields}
          setField={setField}
          handleCancel={() => redirectBack()}
          onboardingBranch={"molecular"}
          useSubmitText={true}
          handleSubmit={handleSubmit}
        />
      )}
    </>
  );
};

ConsentForHealthScreeningForm.propTypes = {
  appData: any,
  postForm: func,
};

const mapDispatchToProps = {
  postForm: postCompleatFoodForm,
};
const mapStateToProps = (state) => ({
  appData: state.core.app,
});

const withRedux = connect(mapStateToProps, mapDispatchToProps);

export default withRedux(ConsentForHealthScreeningForm);
